/* tslint:disable */

/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface RestoreResourceRequest
 */
export interface RestoreResourceRequest {
	/**
	 * RID of the resource
	 * @type {string}
	 * @memberof RestoreResourceRequest
	 */
	rID: string;
}

/**
 * Check if a given object implements the RestoreResourceRequest interface.
 */
export function instanceOfRestoreResourceRequest(value: object): boolean {
	let isInstance = true;
	isInstance = isInstance && 'rID' in value;

	return isInstance;
}

export function RestoreResourceRequestFromJSON(json: any): RestoreResourceRequest {
	return RestoreResourceRequestFromJSONTyped(json, false);
}

export function RestoreResourceRequestFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): RestoreResourceRequest {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		rID: json['RID'],
	};
}

export function RestoreResourceRequestToJSON(value?: RestoreResourceRequest | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		RID: value.rID,
	};
}
